<script>
  import { query as query } from "svelte-apollo";
  import { loading } from '/stores';

  export let gql, variables = null

  const req = query(gql, { variables });
  
  let data = null

  $: {
    if ($req.data) {
      console.log("Query", gql.definitions[0].name.value, $req.data)
      data = $req.data
    }
    $loading = $req.loading
    
    req.refetch({ ...variables });
  }

</script>

{#if $req.loading}

{:else if $req.error}
  Error: {$req.error.message}
{:else}
  {#if $req.data}
    <slot data={data} />
  {/if}
{/if}
